import React from 'react'

import config from '../config.js'

import axios from 'axios'

import { Link, NavLink, Route, Switch } from 'react-router-dom'

import Chapters from './Chapters'
import Cookbooks from './Cookbooks'
import Recipes from './Recipes'
import Recipe from './Recipe'
import ToolbarBackButton from './ToolbarBackButton'

import { urlify } from '../Helpers/urls'
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core/";

class MyLibrary extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sessionId: props.sessionId,
      cookbooks: undefined,
      chapters: [],
      recipes: [],
      recipe: [],
      showDialog: false
    }
  }

  callingAjax = false

  getCookbooks = () => {
    let cookbooks = undefined

    if (this.state.cookbooks !== undefined) {
      cookbooks = this.state.cookbooks
    }

    return cookbooks
  }

  getCookbook = cookbookIdentifier => {
    let cookbook = undefined

    if (this.state.cookbooks) {
      cookbook = this.state.cookbooks.filter(
        item => item.identifier === cookbookIdentifier
      )

      if (cookbook.length > 0) {
        // If by some weird situation there are more than one cookbooks with the same title, return only the first
        cookbook = cookbook[0]
      } else cookbook = null
    } else {
      this.apiGetCookbooks()
    }

    return cookbook
  }

  getChapters = cookbookIdentifier => {
    const cookbook = this.getCookbook(cookbookIdentifier)

    let chapters = undefined

    if (cookbook) {
      if (cookbook.chaptersFetched !== true) {
        this.apiGetChapters(cookbook.uuid, cookbook.identifier)
      } else {
        chapters = this.state.chapters.filter(
          item => item.cookbook === cookbookIdentifier
        )

        // If there are chapters, make sure we've loaded the recipes
        if (chapters.length > 0) {
          chapters.forEach((chapter, index) => {
            if (chapter.recipesFetched !== true) {
              this.apiGetRecipes(
                cookbookIdentifier,
                chapter.uuid,
                chapter.identifier
              )
            } else {
              chapter.recipes = this.getRecipes(
                cookbookIdentifier,
                chapter.identifier
              )
            }
          })
        }
      }
    } else {
      chapters = []
    }

    return chapters
  }

  getChapter = (cookbookIdentifier, chapterIdentifier) => {
    let chapters = this.state.chapters.filter(
      item => item.identifier === chapterIdentifier
    )
    chapters = chapters.filter(item => item.cookbook === cookbookIdentifier)

    let chapter = undefined

    if (chapters.length > 0) {
      // If by some weird situation there are more than one cookbooks with the same name
      // Which ALSO have chapters with the same name, return only the first
      chapter = chapters[0]
    } else {
      const cookbook = this.getCookbook(cookbookIdentifier)

      if (cookbook) {
        if (cookbook.chaptersFetched !== true) {
          this.apiGetChapters(cookbook.uuid, cookbook.identifier)
        } else chapter = null
      }
    }

    return chapter
  }

  getRecipes = (cookbookIdentifier, chapterIdentifier) => {
    const chapter = this.getChapter(cookbookIdentifier, chapterIdentifier)

    let recipes = undefined

    if (chapter) {
      if (chapter.recipesFetched !== true) {
        this.apiGetRecipes(cookbookIdentifier, chapter.uuid, chapter.identifier)
      } else {
        recipes = this.state.recipes.filter(
          item => item.cookbook === cookbookIdentifier
        )
        recipes = recipes.filter(item => item.chapter === chapterIdentifier)
      }
    } else {
      const cookbook = this.getCookbook(cookbookIdentifier)

      if (cookbook) {
        if (cookbook.chaptersFetched !== true) {
          this.apiGetChapters(cookbook.uuid, cookbook.identifier)
        } else {
          recipes = []
        }
      } else {
        recipes = []
      }
    }

    return recipes
  }

  getRecipe = (cookbookIdentifier, chapterIdentifier, recipeIdentifier) => {
    let recipeShort = this.state.recipes.filter(
      item => item.identifier === recipeIdentifier
    )
    recipeShort = recipeShort.filter(item => item.chapter === chapterIdentifier)
    recipeShort = recipeShort.filter(
      item => item.cookbook === cookbookIdentifier
    )

    let recipe = undefined

    if (recipeShort.length > 0) {
      // If by some weird situation there are more than one recipes with the same name
      // Which ALSO belong to chapters with the same name
      // Which ALSO belong to cookbooks with the same name, use only the first (recipe[0])
      const recipeShortId = recipeShort[0].uuid

      if (
        this.state.recipe &&
        (this.state.recipe.length === 0 ||
          this.state.recipe.uuid !== recipeShortId)
      ) {
        this.apiGetRecipe(recipeShortId)
      } else {
        recipe = this.state.recipe
      }
    } else {
      const chapter = this.getChapter(cookbookIdentifier, chapterIdentifier)

      if (chapter !== undefined) {
        if (chapter.recipesFetched !== true) {
          this.apiGetRecipes(
            cookbookIdentifier,
            chapter.uuid,
            chapter.identifier
          )
        } else recipe = null
      } else {
        const cookbook = this.getCookbook(cookbookIdentifier)

        if (cookbook) {
          if (cookbook.chaptersFetched !== true) {
            this.apiGetChapters(cookbook.uuid, cookbook.identifier)
          } else recipe = null
        } else recipe = null
      }
    }

    return recipe
  }

  // See if a chapter has already been loaded into state (current use is to prevent double-loading)
  chapterInState = chapterId => {
    let chapter = this.state.chapters.filter(item => item.uuid === chapterId)

    if (chapter.length > 0) return true
    else return false
  }

  // See if a list recipe has already been loaded into state (current use is to prevent double-loading)
  recipeInState = recipeId => {
    let recipe = this.state.recipes.filter(item => item.uuid === recipeId)

    if (recipe.length > 0) return true
    else return false
  }

  apiLoadData = () => {
    this.apiGetCookbooks()
  }

  apiGetCookbooks = () => {
    if (this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/cookbooks?sid=' +
            this.state.sessionId,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const cookbooksJson = response.data.results
            const cookbooksCount = cookbooksJson.length

            let sortedCookbooks = []

            if (cookbooksCount > 0) {
              for (let i = 0; i < cookbooksCount; i++) {
                // Convert the title and store it as a URL identifier
                cookbooksJson[i].identifier = urlify(cookbooksJson[i].title)

                sortedCookbooks.push(cookbooksJson[i])
              }

              // Sort the array
              sortedCookbooks.sort(function(a, b) {
                return (
                  parseFloat(a['displayOrder']) - parseFloat(b['displayOrder'])
                )
              })

              this.setState((state, props) => ({
                cookbooks: sortedCookbooks
              }))
            } else {
              this.setState((state, props) => ({
                cookbooks: []
              }))
            }
          },
          error => {
            this.callingAjax = false

            console.log(error)
          }
        )
    }
  }

  apiGetChapters = (cookbookUuid, cookbookIdentifier) => {
    if (this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/chapters?sid=' +
            this.state.sessionId +
            '&cbid=' +
            cookbookUuid,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const chaptersJson = response.data.results
            const chaptersCount = chaptersJson.length

            let sortedChapters = []

            // Store some data with each chapter and put each bit of JSON into a new array
            if (chaptersCount > 0) {
              for (let i = 0; i < chaptersCount; i++) {
                // Convert the title and store it as a URL identifier
                chaptersJson[i].identifier = urlify(chaptersJson[i].title)

                // Add the cookbook name to each chapter
                chaptersJson[i].cookbook = cookbookIdentifier

                sortedChapters.push(chaptersJson[i])
              }

              // Sort the array
              sortedChapters.sort(function(a, b) {
                return (
                  parseFloat(a['displayOrder']) - parseFloat(b['displayOrder'])
                )
              })

              // Add a flag to the cookbook to show we've fetched the chapters
              const cookbook = this.getCookbook(cookbookIdentifier)
              if (cookbook) {
                cookbook.chaptersFetched = true
              }

              // Add the array to the existing array of chapters
              this.setState((state, props) => ({
                cookbooks: state.cookbooks,
                chapters: state.chapters.concat(sortedChapters)
              }))
            } else {
              // Add a flag to the cookbook to show we've fetched the chapters
              const cookbook = this.getCookbook(cookbookIdentifier)
              if (cookbook) {
                cookbook.chaptersFetched = true
              }

              // Add the array to the existing array of chapters
              this.setState((state, props) => ({
                cookbooks: state.cookbooks
              }))
            }
          },
          error => {
            this.callingAjax = false

            console.log(error)
          }
        )
    }
  }

  apiGetRecipes = (cookbookIdentifier, chapterUuid, chapterIdentifier) => {
    if (this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/recipes?sid=' +
            this.state.sessionId +
            '&chid=' +
            chapterUuid,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const recipesJson = response.data.results
            const recipesCount = recipesJson.length

            let sortedRecipes = []

            // Store some data with each recipe and put each bit of JSON into a new array
            if (recipesCount > 0) {
              for (let i = 0; i < recipesCount; i++) {
                if (!this.recipeInState(recipesJson[i].uuid)) {
                  // Convert the title and store it as a URL identifier
                  recipesJson[i].identifier = urlify(recipesJson[i].title)

                  // Add the cookbook name to each recipe
                  recipesJson[i].cookbook = cookbookIdentifier
                  // Add the chapter name to each recipe
                  recipesJson[i].chapter = chapterIdentifier

                  sortedRecipes.push(recipesJson[i])
                }
              }

              // Sort the array
              sortedRecipes.sort(function(a, b) {
                return (
                  parseFloat(a['displayOrder']) - parseFloat(b['displayOrder'])
                )
              })

              // Add a flag to the chapter to show we've fetched the recipes
              // Also store the recipe count with the chapter
              const chapter = this.getChapter(
                cookbookIdentifier,
                chapterIdentifier
              )
              if (chapter !== undefined) {
                chapter.recipesFetched = true
                chapter.recipesCount = recipesCount

                // Add the array to the existing array of recipes
                this.setState((state, props) => ({
                  chapters: state.chapters,
                  recipes: state.recipes.concat(sortedRecipes)
                }))
              }
            } else {
              // Add a flag to the chapter to show we've fetched the recipes
              const chapter = this.getChapter(
                cookbookIdentifier,
                chapterIdentifier
              )
              if (chapter !== undefined) {
                chapter.recipesFetched = true

                // Update the chapters state
                this.setState((state, props) => ({
                  chapters: state.chapters
                }))
              }
            }
          },
          error => {
            this.callingAjax = false

            console.log(error)
          }
        )
    }
  }

  apiGetRecipe = recipeId => {
    if (this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/recipe?sid=' +
            this.state.sessionId +
            '&rid=' +
            recipeId,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const recipeJson = response.data.result

            if (recipeJson.recipe) {
              this.setState((state, props) => ({
                recipe: recipeJson.recipe
              }))
            }
          },
          error => {
            this.callingAjax = false

            console.log(error)
          }
        )
    }
  }

  ConfirmDialog(open, onResult) {
    return (
      <Dialog open={open} onClose={() => onResult(false)}>
        <DialogTitle>This feature has not been added to the Cook'n Web App yet.<br/><br/>To add recipes to your Cook'n Library, please install the Cook'n App.</DialogTitle>
        <DialogActions>
          <Button onClick={() => onResult(false)}>Later</Button>
          <Button onClick={() => onResult(true)} autoFocus>Install Cook'n</Button>
        </DialogActions>
      </Dialog>
    )
  }

  componentDidMount() {
    this.apiLoadData()
  }

  render() {
    return (
      <div>
        {this.ConfirmDialog(this.state.showDialog, (confirmed) => {
          this.setState((state, props) => ({
            showDialog: false
          }))
          if (confirmed) {
            console.log("Dialog Confirmed")
            window.location.href = "https://www.dvo.com/download.php"
          }
        })}
        <nav className="panel-toolbar">
          <ul>
            <li>
              <ToolbarBackButton />
            </li>
            <li>
              <NavLink to={`${this.props.match.url}`} activeClassName="active">
                <span className="material-icons md-36">home</span>
                <br />
                <span className="icon-text">Library</span>
              </NavLink>
            </li>
            <li>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  this.setState((state, props) => ({
                    showDialog: true
                  }))

                }}
              >
                <span className="material-icons md-36">playlist_add</span>
                <br />
                <span className="icon-text">Add/Edit Recipe</span>
              </a>
            </li>
            {/*<li>
                <a href="#">
                    <span className="material-icons md-36">update</span><br /><span className="icon-text">Refresh</span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span className="material-icons md-36">backup</span><br /><span className="icon-text">Sync</span>
                </a>
            </li>*/}
          </ul>
        </nav>

        <Route
          path={`${
            this.props.match.url
          }/:cookbookIdentifier/:chapterIdentifier?/:recipeIdentifier?`}
          render={({ match }) => {
            let baseLink,
              cookbookLink,
              chapterLink,
              recipeTitle = ''

            let cookbook,
              chapter,
              recipe = null

            if (match.params.cookbookIdentifier)
              cookbook = this.getCookbook(match.params.cookbookIdentifier)
            if (match.params.chapterIdentifier)
              chapter = this.getChapter(
                match.params.cookbookIdentifier,
                match.params.chapterIdentifier
              )
            if (match.params.recipeIdentifier)
              recipe = this.getRecipe(
                match.params.cookbookIdentifier,
                match.params.chapterIdentifier,
                match.params.recipeIdentifier
              )

            if (cookbook) {
              baseLink = (
                <li>
                  <Link to={`${this.props.match.url}`}>
                    My Cookbook Library
                  </Link>
                </li>
              )

              if (chapter)
                cookbookLink = (
                  <li>
                    <Link
                      to={
                        `${this.props.match.url}/` +
                        match.params.cookbookIdentifier
                      }
                    >
                      {cookbook.title}
                    </Link>
                  </li>
                )
              else
                cookbookLink = (
                  <li>
                    <span>{cookbook.title}</span>
                  </li>
                )
            }
            if (chapter) {
              if (recipe)
                chapterLink = (
                  <li>
                    <Link
                      to={
                        `${this.props.match.url}/` +
                        match.params.cookbookIdentifier +
                        '/' +
                        match.params.chapterIdentifier
                      }
                    >
                      {chapter.title}
                    </Link>
                  </li>
                )
              else
                chapterLink = (
                  <li>
                    <span>{chapter.title}</span>
                  </li>
                )
            }
            if (recipe) {
              recipeTitle = (
                <li>
                  <span>{recipe.name}</span>
                </li>
              )
            }

            return (
              <nav className="breadcrumbs">
                <ol>
                  {baseLink}
                  {cookbookLink}
                  {chapterLink}
                  {recipeTitle}
                </ol>
              </nav>
            )
          }}
        />

        <Switch>
          <Route
            exact
            path={`${this.props.match.url}`}
            render={({ match }) => (
              <Cookbooks
                baseUrl={match.url}
                theme={this.props.theme}
                cookbooks={this.getCookbooks()}
                title={'My Cookbook Library'}
                context={'MyLibrary'}
              />
            )}
          />
          <Route
            exact
            path={`${this.props.match.url}/:cookbookIdentifier`}
            render={({ match }) => (
              <Chapters
                cookbookUrl={match.url}
                cookbook={this.getCookbook(match.params.cookbookIdentifier)}
                chapters={this.getChapters(match.params.cookbookIdentifier)}
              />
            )}
          />
          <Route
            exact
            path={`${
              this.props.match.url
            }/:cookbookIdentifier/:chapterIdentifier`}
            render={({ match }) => (
              <Recipes
                chapterUrl={match.url}
                chapter={this.getChapter(
                  match.params.cookbookIdentifier,
                  match.params.chapterIdentifier
                )}
                recipes={this.getRecipes(
                  match.params.cookbookIdentifier,
                  match.params.chapterIdentifier
                )}
              />
            )}
          />
          <Route
            exact
            path={`${
              this.props.match.url
            }/:cookbookIdentifier/:chapterIdentifier/:recipeIdentifier/:recipeId`}
            render={({ match }) => (
              <Recipe
                recipe={this.getRecipe(
                  match.params.cookbookIdentifier,
                  match.params.chapterIdentifier,
                  match.params.recipeIdentifier
                )}
                userLoggedIn={true}
              />
            )}
          />
        </Switch>
      </div>
    )
  }
}

export default MyLibrary



// WEBPACK FOOTER //
// ./src/Components/MyLibrary.js